import UserPlus from '@/assets/icons/user-plus.svg?react';
import { Loadable } from '@/components/loaders';
import RouteConstants from '@/features/router/RouteConstants';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetAudiencesByIdsQuery } from '@/services/endpoints/audiences';
import { FC } from 'react';
import { UnifiedProfileItem, UnifiedProfileSection, UnifiedProfileSectionEmptyMessage, UnifiedProfileTile } from '../../common';

type UnifiedProfileAudiencesSectionProps = {
  audienceIds: string[];
};

export const UnifiedProfileAudiencesSection: FC<UnifiedProfileAudiencesSectionProps> = ({ audienceIds }) => {
  const workspace = useWorkspace();

  const { data: audiences, isFetching: isAudiencesFetching } = useGetAudiencesByIdsQuery(
    {
      workspaceId: workspace.id,
      audienceIds,
    },
    {
      skip: !audienceIds,
    }
  );

  return (
    <UnifiedProfileSection header='userUsedInAudiences' headerIcon={<UserPlus />}>
      <UnifiedProfileTile className='divide-y divide-gray-200 p-0'>
        <Loadable className='h-full' isLoading={isAudiencesFetching}>
          {audiences?.length ? (
            audiences?.map((audience) => <UnifiedProfileItem key={audience.id} name={audience.name} link={`${RouteConstants.audiences}/${audience.id}`} />)
          ) : (
            <UnifiedProfileSectionEmptyMessage labelKey='userUsedInAudiences_empty' />
          )}
        </Loadable>
      </UnifiedProfileTile>
    </UnifiedProfileSection>
  );
};
